import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { MultiPaymentTermsSelectorModule } from './multi-payment-terms-selector/multi-payment-terms-selector.module';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(MultiPaymentTermsSelectorModule)
  .catch((err) => console.error(err));
